import * as React from 'react';
import PageContainer from './PageContainer';
import classnames from 'classnames';
import DragContext from '../../utils/dragDropContext';
import { bindMethods } from '../../utils/core';
import { connect } from 'react-redux';
import { fetchPage } from '../../actions/reduxActions/pageEditor';
import { CONTAINER_TYPE, PAGE_ELEMENTS } from './pageEditorConstants';
import SideBarComponent from './SideBarComponent';
import '../../../css/page/page-editor-v2.less';

const mapStateToProps = ({ pageEditor }) => ({ pageEditor });

const mapDispatchToProps = {
    fetchPage,
};

class PageEditorLayout extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sidebarExpanded: true,
        };

        bindMethods(
            this,
            'toggleSidebar',
            'selectOnFocus',
        );
    }

    componentDidMount() {
        this.props.fetchPage(this.props.authToken, this.props.pageId);
    }

    componentDidUpdate() {

        // This allows for switching between page tabs
        if (this.props.pageEditor.id !== this.props.pageId && this.props.isActive) {
            this.props.fetchPage(this.props.authToken, this.props.pageId);
        }
    }

    nestPageContainers = (container) => {
        const children = this.props.pageEditor.pageContainers.filter(
            childContainer => childContainer.parentId === container.id,
        );

        return (
            <PageContainer
                key={container.id}
                order={container.order}
                id={container.id}
                isActive={container.isActive}
                type={container.containerType === CONTAINER_TYPE.row ? PAGE_ELEMENTS.row_container : PAGE_ELEMENTS.column_container}
                parentId={container.parentId}
            >
                {children.map(this.nestPageContainers)}
            </PageContainer>
        );
    }

    toggleSidebar() {
        this.setState({ sidebarExpanded: !this.state.sidebarExpanded });
    }

    selectOnFocus(event) {
        event.target.select();
    }

    render() {
        const sidebarClasses = classnames({
            'page-edit-sidebar': true,
            expanded: this.state.sidebarExpanded,
        });

        if (this.props.pageEditor) {
            const { pageContainers } = this.props.pageEditor;
            const rootContainer = pageContainers.find(
                root => root.parentId === null,
            );
            return (
                <div className="page-edit">
                    <div className={sidebarClasses}>
                        <ul className="component-types">
                            <li>
                                <span className="component-types-label">Containers</span>
                                <ul className="component-list">
                                    <li className="component-list-item">
                                        <SideBarComponent component={PAGE_ELEMENTS.row_container} />
                                    </li>
                                    <li className="component-list-item">
                                        <SideBarComponent component={PAGE_ELEMENTS.column_container} />
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <span className="component-types-label">Data</span>
                                <ul className="component-list" />
                            </li>
                        </ul>
                        <div className="sidebar-toggle-bar">
                            <button
                                className="sidebar-toggle-button"
                                onClick={this.toggleSidebar}
                            >
                                {
                                    this.state.sidebarExpanded ? '<' : '>'
                                }
                            </button>
                        </div>
                    </div>
                    <div className="page-edit-wrapper flex-column">
                        <div className="page-edit-controls">
                            <div className="flex">
                                <input className="page-edit-name" defaultValue={this.props.pageEditor.developerName} onFocus={this.selectOnFocus} />
                                <button className="btn btn-success btn-sm flex-child-right ">
                                    <span className=" glyphicon glyphicon-save" />
                                    { ' Save' }
                                </button>
                            </div>
                        </div>
                        <div className="page-edit-canvas-wrapper">
                            {
                                pageContainers ? (
                                    <React.Fragment>
                                        {this.nestPageContainers(rootContainer)}
                                    </React.Fragment>
                                ) : null
                            }
                        </div>
                    </div>
                </div>
            );
        }
        return null;
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DragContext(PageEditorLayout));
